import { FaCheck } from "react-icons/fa";
import * as s from "../EditRecorderStyled";

export interface ThumbnailGridItem {
  id: string;
  name: string;
  imageUrl: string;
}

interface Props {
  items: ThumbnailGridItem[];
  selectedId: string;
  onSelect: (id: string) => void;
  imageFit?: "cover" | "contain";
}

export default function ThumbnailImageGrid({
  items,
  selectedId,
  onSelect,
  imageFit = "cover",
}: Props): JSX.Element {
  return (
    <s.CameraGrid>
      {items.map((item) => (
        <s.CameraThumbButton
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          selected={selectedId === item.id}
          imageFit={imageFit}
          data-testid="recorders-edit-thumbnail-camera-thumb-button-select"
        >
          <img src={item.imageUrl} alt={item.name} />
          {selectedId === item.id && (
            <span className="selected-mark">
              <FaCheck />
            </span>
          )}
        </s.CameraThumbButton>
      ))}
    </s.CameraGrid>
  );
}
